<template>
  <div>
    <MSnackbar
      v-for="notification in notifications"
      :key="notification.id"
      v-model="notification.visible"
      :color="notification.type"
      :timeout="notification.duration || 5000"
      location="top"
    >
      <div class="d-flex align-center">
        <MIcon :icon="getNotificationIcon(notification.type)" class="mr-2" />
        <div>
          <div v-if="notification.title" class="font-weight-medium">{{ notification.title }}</div>
          <div>{{ notification.message }}</div>
        </div>
      </div>

      <template #actions>
        <MBtn icon variant="text" size="small" @click="removeNotification(notification.id)">
          <MIcon icon="close" size="small" color="white" />
        </MBtn>
      </template>
    </MSnackbar>
  </div>
</template>

<script setup lang="ts">
import { useUIStore } from '~/stores/ui'

const uiStore = useUIStore()

const notifications = computed(() =>
  uiStore.notifications.map(notification => ({
    ...notification,
    visible: true,
  })),
)

const removeNotification = (id: string) => {
  uiStore.removeNotification(id)
}

const getNotificationIcon = (type: string) => {
  switch (type) {
    case 'success': return 'check-circle'
    case 'error': return 'alert-circle'
    case 'warning': return 'alert'
    case 'info':
    default: return 'information'
  }
}
</script>
